/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LabelValue } from './LabelValue';
import {
    LabelValueFromJSON,
    LabelValueFromJSONTyped,
    LabelValueToJSON,
} from './LabelValue';

/**
 * 
 * @export
 * @interface RegisterStatistics
 */
export interface RegisterStatistics {
    /**
     * 
     * @type {Array<LabelValue>}
     * @memberof RegisterStatistics
     */
    registers: Array<LabelValue>;
    /**
     * 
     * @type {Array<LabelValue>}
     * @memberof RegisterStatistics
     */
    consultations: Array<LabelValue>;
}

/**
 * Check if a given object implements the RegisterStatistics interface.
 */
export function instanceOfRegisterStatistics(value: object): value is RegisterStatistics {
    if (!('registers' in value) || value['registers'] === undefined) return false;
    if (!('consultations' in value) || value['consultations'] === undefined) return false;
    return true;
}

export function RegisterStatisticsFromJSON(json: any): RegisterStatistics {
    return RegisterStatisticsFromJSONTyped(json, false);
}

export function RegisterStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'registers': ((json['registers'] as Array<any>).map(LabelValueFromJSON)),
        'consultations': ((json['consultations'] as Array<any>).map(LabelValueFromJSON)),
    };
}

export function RegisterStatisticsToJSON(value?: RegisterStatistics | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'registers': ((value['registers'] as Array<any>).map(LabelValueToJSON)),
        'consultations': ((value['consultations'] as Array<any>).map(LabelValueToJSON)),
    };
}

